/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{parseUrl as o}from"../utils.js";import{executeQueryForCount as r}from"./operations/query.js";import t from"../support/Query.js";async function s(s,i,m){const n=o(s),{data:p}=await r(n,t.from(i),m);return p.count}export{s as executeForCount};
